
export class AppConstants {
            }